import React, { Component } from "react";
import sysJwt from "../../utils/sysJwt";
import AppRoutes from "./routes";
import { ToastContainer, Flip } from "react-toastify";
import Aside from "../commonComponents/Aside";
import { withTranslation } from "react-i18next";
import "../../styles/modern.css";

class Dashboard extends Component {
  state = {
    Username: "",
    isLoading: false,
    tempSharedData: {},
  };

  componentDidMount() {
    this.setState({ Username: sysJwt.getUsername() });
  }

  handleIsLoadingChange = (isLoadingStatus) => {
    this.setState({ isLoading: isLoadingStatus });
  };

  updateTempSharedData = (tempData) => {
    this.setState({ tempSharedData: tempData });
  };

  handleLogOut = () => {
    sessionStorage.removeItem("748784");
    window.location.replace("/login");
  };

  render() {
    const { isLoading, Username } = this.state;

    return (
      <React.Fragment>
        {isLoading && <div className="topbar-loading-bar" />}

        <div className="app-wrapper">
          <Aside
            username={Username}
            isLoading={isLoading}
            handleLogout={this.handleLogOut}
          />

          <div className="main-area">
            <main className="page-content">
              <AppRoutes
                isLoading={isLoading}
                tempSharedData={this.state.tempSharedData}
                updateIsLoading={(status) => this.handleIsLoadingChange(status)}
                updateTempSharedData={(data) => this.updateTempSharedData(data)}
              />
            </main>
          </div>
        </div>

        <ToastContainer
          position="top-center"
          autoClose={4000}
          hideProgressBar={false}
          closeButton={false}
          rtl={["ar", "ku"].includes(
            (localStorage.getItem("cma_language") || "en").split("-")[0]
          )}
          transition={Flip}
          newestOnTop
          closeOnClick
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </React.Fragment>
    );
  }
}

export default withTranslation()(Dashboard);
